import axios from "axios";
import store from "../store";
import { LOGOUT } from "../store/modules/auth";

const baseURL = process.env.VUE_APP_API_URI;
const Api = axios.create({
  baseURL: baseURL
});

Api.interceptors.request.use(
  config => {
    const token = store.getters["token"];
    if (token) {
      config.headers.common["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  error => Promise.reject(...error)
);

Api.interceptors.response.use(
  response => response,
  error => {
    if (error?.response?.status === 401) {
      store.dispatch(LOGOUT);
    }
    if ([404, 405, 500].includes(error?.response?.status)) {
      let errorMessage =
        "An unexpected error occurred. Please try again later.";
      throw {
        ...error,
        response: {
          ...error.response,
          data: {
            ...error.response.data,
            message: errorMessage
          }
        }
      };
    }
    throw error;
  }
);
export default Api;
